module.exports = __webpack_public_path__ + "img/badbitch.8378fb6d.png";